module.exports = __webpack_public_path__ + "img/00_Fragezeichen.9235b567.svg";